var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C8.125 0 10 3 10 3C10 3 8.125 6 5 6C1.875 6 0 3 0 3C0 3 1.875 0 5 0ZM5 0.545455C2.8 0.545455 1.24875 2.31873 0.734375 3C1.24812 3.68073 2.79938 5.45455 5 5.45455C7.2 5.45455 8.75125 3.68127 9.26562 3C8.75187 2.31927 7.20062 0.545455 5 0.545455ZM5 1.09091C5.58016 1.09091 6.13656 1.29204 6.5468 1.65007C6.95703 2.00809 7.1875 2.49368 7.1875 3C7.1875 3.50632 6.95703 3.99191 6.5468 4.34993C6.13656 4.70796 5.58016 4.90909 5 4.90909C4.41984 4.90909 3.86344 4.70796 3.4532 4.34993C3.04297 3.99191 2.8125 3.50632 2.8125 3C2.8125 2.49368 3.04297 2.00809 3.4532 1.65007C3.86344 1.29204 4.41984 1.09091 5 1.09091ZM5 1.63636C4.58575 1.6368 4.18861 1.7806 3.89569 2.03624C3.60278 2.29188 3.438 2.63847 3.4375 3C3.4375 3.75164 4.13812 4.36364 5 4.36364C5.86188 4.36364 6.5625 3.75164 6.5625 3C6.5625 2.24836 5.86188 1.63636 5 1.63636Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7e06bc658ae5f45a6efdbb6221208cd2.svg";
export { ForwardRef as ReactComponent };